import { lazy, Suspense } from 'react'
import { redirect } from 'react-router-dom'
import axios from 'axios'

import Layout from 'Components/Layout'
import Spinner from 'Components/Spinner'
import SearchPage from 'Pages/SearchPage'
import ErrorPage from 'Pages/ErrorPage'

const DetailPage = lazy(() => import('./Pages/DetailPage'))

export default [
	{
		path: '/',
		element: <Layout />,
		errorElement: <ErrorPage />,
		children: [
			{ index: true, element: <SearchPage /> },
			{
				path: '/:gensetSerial',
				loader: ({ params }) =>
					axios
						.post(
							'/api/Home/SearchGetEquipDetailReturn',
							{
								gensetSerial: params.gensetSerial,
							},
							{
								headers: {
									'Content-Type': 'multipart/form-data',
								},
							}
						)
						.then(({ data }) => data),
				element: (
					<Suspense fallback={<Spinner />}>
						<DetailPage />
					</Suspense>
				),
			},
		],
	},
	{
		path: '/Home/Index',
		loader: () => redirect('/'),
	},
]

